import React, { useEffect } from "react";
import Highcharts from "highcharts";
require("highcharts/modules/accessibility")(Highcharts);
var currentYear = new Date().getFullYear();
export default function MeanAPEGraph({ summaryReports }) {
    function getLevelsText(summaryReports) {
        const levels = [];
        if (summaryReports?.optionsAvailable?.REGULAR) levels.push("Regular");
        if (summaryReports?.optionsAvailable?.MIDGRADE) levels.push("Midgrade");
        if (summaryReports?.optionsAvailable?.PREMIUM) levels.push("Premium");

        if (levels.length === 0) return "";
        if (levels.length === 2) return `${levels[0]} and ${levels[1]}`;
        if (levels.length > 2) {
            return levels.slice(0, -1).join(", ") + " and " + levels.slice(-1);
        }
        return levels[0];
    }
    function applyMapeAccessibility(chart) {
        if (chart && chart.renderTo) {
            const svg = chart.renderTo.querySelector("svg.highcharts-root");
            if (svg) {
                setTimeout(() => {
                    const levelsText = getLevelsText(summaryReports);
                    svg.setAttribute("role", "img");
                    svg.setAttribute(
                        "aria-label",
                        `MAPE Comparison chart showing forecast accuracy for ${levelsText} gasoline types for the years.`
                    );

                    const oldDesc = svg.querySelector("desc");
                    if (oldDesc) oldDesc.remove();

                    const desc = document.createElementNS("http://www.w3.org/2000/svg", "desc");
                    desc.textContent =
                        `This chart compares the Mean Absolute Percentage Error values across ${levelsText} gasoline types for the forecast years. Lower MAPE values indicate more accurate forecasts.`;
                    svg.insertBefore(desc, svg.firstChild);
                }, 0);
            }
        }
    }

    var chart = {
        type: 'column',
        events: {
            render: function () {
            applyMapeAccessibility(this);
            },
            redraw: function () {
            applyMapeAccessibility(this);
            }
        }
    };
    var title = {
        text: "MAPE Comparison",
        align: "left",
        style: {
            fontSize: "14px",
        },
    };
    var credits = {
        enabled: false, // Disable the Highcharts bottom link
    };
    var tooltip = {
       // format: '<strong>{key}</strong><br/>{series.name}: <strong>{y}</strong><br/>',
        formatter: function () {
            var tooltipText = `<strong>${this.x}</strong>`+ '<br/>';
            if (this.series.name === `${currentYear}-${currentYear + 1}`) {
              tooltipText += '<span style="color: #BB4A28;">' + this.series.name + '</span>: <strong style="font-weight: bold;">' + Highcharts.numberFormat(this.y) + '%' + '</strong>';
            } else if (this.series.name === `${currentYear + 1}-${currentYear + 2}`) {
              tooltipText += '<span style="color: #005A70;">' + this.series.name + '</span>: <strong style="font-weight: bold;">' + Highcharts.numberFormat(this.y) + '%' + '</strong>';
            }
            return tooltipText;
          },
        borderWidth: 1,
        style: {
            borderColor: function () {
                return this.point.color; // Set the tooltip box border color to match the point color
            },
            opacity: 0.9,
            fontSize: '14px',
        }
    };
    var legend = {
        enabled: false,
        align: "left",
        itemStyle: {
            fontWeight: "bold",
            fontSize: "11px",
        },
    };

    var plotOptions = {
        column: {

            dataLabels: {
                enabled: false,
                style: {
                    textOutline: "none",
                },
            },
        },
        series:{
            events: {
                legendItemClick: function(e) {
                    return false;
                }
              }
        }
    };
    var series = [
        {
            name: `${currentYear}-${currentYear + 1}`,
            data: [],
            //color: "#BB4A28",
            color: {
                pattern: {
                  path: 'M 0 0 L 10 10 M 0 10 L 10 0', // Diagonal cross pattern
                  width: 10,
                  height: 10,
                  color: "#BB4A28",
                }
              }
        },
        {
            name: `${currentYear + 1}-${currentYear + 2}`,
            data: [],
            //color: "#005A70",
            color: {
                pattern: {
                    path: 'M 0 5 L 10 5', // Horizontal line
                    width: 10,
                    height: 10,
                    color: '#FFFFFF', // Line color (white)
                    backgroundColor: '#005A70' 
                }
            },
        }
    ];
    var xAxis = {
        categories: [],
        title: {
            text: "Gasoline Type",
        },
        lineColor: '#EFEFEC'
    }
    var yAxis = {
        allowDecimals: false,
        crosshair: true,
        min: 0,
        title: {
            text: 'MAPE (in %)'
        }
    }
    var accessibility = {
        enabled: true,
        screenReaderSection: {
            beforeChartFormat: '' // disables the default label
        }
    };
    var json = {};
    json.chart = chart;
    json.credits = credits;
    json.title = title;
    json.tooltip = tooltip;
    json.legend = legend;
    json.series = series;
    json.xAxis = xAxis;
    json.yAxis = yAxis;
    json.plotOptions = plotOptions;
    json.accessibility = accessibility;
    const initGraph = () => {
        let xAxisCategories = []
        let series0Data = []
        let series1Data = []
        for (const key in summaryReports?.optionsAvailable) {
            if (summaryReports?.optionsAvailable[key]) {
              xAxisCategories.push(key);
              series0Data.push(summaryReports?.DemandAnalysis?.currentYearMapeValue[key])
              series1Data.push(summaryReports?.DemandAnalysis?.nextYearMapeValue[key])
            }
        }
        json.xAxis.categories = xAxisCategories;
        json.series[0].data = series0Data
        json.series[1].data = series1Data
        Highcharts.chart("MeanAPEGraph", json);
        //console.log(json);
    };
    useEffect(() => {
        initGraph();
    }, [summaryReports]);
    return (
        <div
            id="MeanAPEGraph"
            style={{ height: "340px" }}
            title={title.text}
            aria-label="Cost Analysis Graph"
            className="costAnalysis"
        ></div>
    );
}
